/* eslint-disable  @typescript-eslint/no-explicit-any */

export const environment = {
  VUE_APP_API_URL: (window as any)._env.VUE_APP_API_URL as string,
  VUE_APP_MODE: (window as any)._env.VUE_APP_MODE as string,
}
